import { Permission, userHasPermission } from "../../../../utils/permissions";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectKbHash } from "~/Configurators/Linear/redux/selectors";
import { selectPriceData } from "~/redux/products/productsSelectors";
import { requestPriceData } from "~/redux/products/actions";
import { useLinearProductInfo } from "~/Configurators/Linear/redux/useLinearProductInfo";

interface Props {
  priceReference: string;
}

let lastKbHash = "";

function isNewKbHash(kbHash: string) {
  return lastKbHash !== kbHash;
}

export const userCanPurchaseLinear = () => userHasPermission(Permission.LINEAR_PURCHASE);

export const useLinearPrice = ({ priceReference }: Props) => {
  const configuratorProduct = useLinearProductInfo();

  const kbHash = useSelector(selectKbHash) + "-" + priceReference;

  const dispatch = useDispatch();
  const { state, data } = useSelector(selectPriceData({ productCode: configuratorProduct.code, priceReference })) ?? {
    state: kbHash ? "loading" : "loaded",
    data: undefined,
  };

  useEffect(() => {
    if (isNewKbHash(kbHash)) {
      lastKbHash = kbHash;
      dispatch(requestPriceData(configuratorProduct, priceReference, undefined, undefined, true));
    }
  }, [configuratorProduct.configId, priceReference, kbHash]);

  return {
    priceInfo: data?.[0] ?? null,
    errorLoadingPrice: state === "error",
    isLoadingPrice: state === "loading",
  };
};
